let notices = [];
let nextId = 0;
const listeners = new Set();

export const getNotifications = () => notices;

export const subscribeNotifications = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const publish = () => listeners.forEach((listener) => listener());

export const dismissNotification = (id) => {
  notices = notices.filter((notice) => notice.id !== id);
  publish();
};

export const notify = (message, tone = "success") => {
  if (!String(message || "").trim()) return;
  const notice = { id: ++nextId, message: String(message).trim(), tone };
  // Repeated quick edits should not cover the screen with identical notices.
  notices = [...notices.filter((item) => item.message !== notice.message || item.tone !== tone), notice].slice(-3);
  publish();
  return notice.id;
};

export const notifySuccess = (message) => notify(message, "success");
export const notifyInfo = (message) => notify(message, "info");
